import React, { useCallback, useEffect, useState, useContext } from "react";
import {
	Grid,
	Typography,
	DialogTitle,
	Slide,
	Dialog,
	DialogContent,
	Select,
	MenuItem,
	Button,
	Checkbox,
} from "@material-ui/core";
import CorporateGuarantor from "./CorporateGuarantor";
import PersonalGuarantor from "./PersonalGuarantor";
import { GuarantorsDataAPI } from "../../../API/GuarantorsDataAPI";
import NmefSpinner from "../../../NmefSpinner";
import { validateDate } from "../../../Constants/utils";
import AppContext from "../../../DocsFunding/ContextCreation/AppContext";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

export default function GuarantorEdit({
	editGuarantorFlag,
	setEditGuarantorFlag,
	guarantor,
	guarantors,
	setGuarantors,
	brokerId,
	setAddGuarantor,
	app,
	setGuarantorDataList,
	usStates
}) {
	const { setGuarantorData } = useContext(AppContext);
	const [guarInfo, setGuarInfo] = useState({});
	const [spinner, setSpinner] = useState(false);
	const guarantorTypeChoices = ["Personal", "Corporate", "Contact Only"];
	const [UI, setUI] = useState();
	const [errorFlag, setErrorFlag] = useState(false);
	const [usStateNames, setStateNames] = useState([]);
	const handleCancel = () => {
		setUI()
		setEditGuarantorFlag(!editGuarantorFlag);
		setGuarInfo(guarantor);
		setAddGuarantor(false);
	};
	useEffect(() => {
		if (errorFlag) {
			setTimeout(() => {
				setErrorFlag(false);
			}, 2000);
		}
	}, [errorFlag, UI]);
	const applicationGuarantorDataList = (element) => {
		let result = {
			name:
				element.guarantor_type === "Corporate"
					? element.guarantor?.organization_name
					: element.guarantor?.first_name + " " + element.guarantor?.last_name,
			Percent_of_Ownership:
				element.guarantor_type
					? element?.percent_of_ownership : 0,
			SSN_FEIN:
				element.guarantor_type === "Corporate"
					? element.guarantor?.fein
					: element.guarantor?.ssn,
			Date_of_Birth:
				element.guarantor_type === "Corporate"
					? "N/A"
					: element.guarantor?.date_of_birth,
			Phone: element.guarantor?.telephone,
			Marital_Status:
				element.guarantor_type === "Corporate"
					? "N/A"
					: element.guarantor?.marital_status,
			Address:
				element.guarantor?.address +
				" " +
				element.guarantor?.city +
				", " +
				element.guarantor?.state +
				" ," +
				element.guarantor?.zip_code,
		};
		return result;
	};
	const isFormValidPersonal = () =>
		guarInfo.guarantor?.first_name &&
		guarInfo.guarantor?.last_name &&
		guarInfo.percent_of_ownership?.toString() &&
		guarInfo.guarantor?.ssn &&
		guarInfo.guarantor?.city &&
		guarInfo.guarantor?.state &&
		guarInfo.guarantor?.address &&
		guarInfo.guarantor?.telephone &&
		guarInfo.guarantor?.zip_code;

	const isFormValidCorporate = () =>
		guarInfo.percent_of_ownership?.toString() &&
		guarInfo.guarantor?.organization_name &&
		guarInfo.guarantor?.business_start_date &&
		guarInfo.guarantor?.fein &&
		guarInfo.guarantor?.city &&
		guarInfo.guarantor?.address &&
		guarInfo.guarantor?.telephone &&
		guarInfo.guarantor?.state &&
		guarInfo.guarantor?.zip_code;

	const saveGuarantor = useCallback(async () => {
		setUI();
		let err;
		try {
			let putGuarantor = { ...guarInfo };
			if (guarInfo.guarantor_type === "Corporate") {
				putGuarantor.guarantor.record_type = "Corporate Guarantor";
				if (guarInfo.guarantor?.business_start_date && !validateDate(guarInfo.guarantor?.business_start_date, true)) {
					err = "Please enter the valid date field";
					return;
				}
			} else if (guarInfo.guarantor_type === "Personal" || guarInfo.guarantor_type === "Contact Only") {
				putGuarantor.guarantor.record_type = "Personal Guarantor";
				if (guarInfo.guarantor?.date_of_birth && !validateDate(guarInfo.guarantor?.date_of_birth)) {
					err = "Please enter the valid date field";
					return;
				}
			}
			setSpinner(true);
			if (putGuarantor.guarantor.id) {
				await GuarantorsDataAPI.putRequestGuarantor(putGuarantor.guarantor);
				let updatedGuarantors = guarantors?.map((guar) => {
					if (guar.id === putGuarantor.id) {
						return putGuarantor;
					} else return guar;
				});
				setGuarantors(updatedGuarantors);
				await GuarantorsDataAPI.updateGuarantor(updatedGuarantors, brokerId, app.locked_by_email);
			} else {
				let newGuarantors = JSON.parse(JSON.stringify(guarantors)); //shallow copy
				newGuarantors.map((guarantorItem) => {
					if (guarInfo.guarantor_id === guarantorItem.guarantor_id) {
						guarantorItem.guarantor_type = guarInfo.guarantor_type;
						guarantorItem.relationship_to_applicant =
							guarInfo.relationship_to_applicant;
						guarantorItem.percent_of_ownership = guarInfo.percent_of_ownership;
						guarantorItem.guarantor = guarInfo.guarantor;
						if (guarInfo.guarantor_type === "Contact Only") {
							guarantorItem.is_corporate_guarantor = false;
							guarantorItem.is_contact_only = true;
							guarantorItem.is_personal_guarantor = false;
							guarantorItem.marital_status = guarInfo.marital_status;
						} else if (guarInfo.guarantor_type === "Corporate") {
							guarantorItem.is_corporate_guarantor = true;
							guarantorItem.is_contact_only = false;
							guarantorItem.is_personal_guarantor = false;
							guarantorItem.business_entity_type = guarInfo.business_entity_type;
							guarantorItem.guarantor.record_type = "Corporate Guarantor";
						} else if (guarInfo.guarantor_type === "Personal") {
							guarantorItem.is_corporate_guarantor = false;
							guarantorItem.is_contact_only = false;
							guarantorItem.is_personal_guarantor = true;
							guarantorItem.this_guarantor_has_signed_the_credit_application =
								guarInfo.this_guarantor_has_signed_the_credit_application;
							guarantorItem.marital_status = guarInfo.marital_status;
							guarantorItem.guarantor.record_type = "Personal Guarantor";
						}
						putGuarantor = guarantorItem.guarantor;
					}
				});
				putGuarantor = { ...guarInfo };
				if (guarInfo.guarantor_type === "Contact Only") {
					putGuarantor.is_corporate_guarantor = false;
					putGuarantor.is_contact_only = true;
					putGuarantor.is_personal_guarantor = false;
					putGuarantor.marital_status = guarInfo.marital_status;
					putGuarantor.guarantor.lessee = app?.lessee;
					putGuarantor.primary = false;
				} else if (guarInfo.guarantor_type === "Corporate") {
					putGuarantor.is_corporate_guarantor = true;
					putGuarantor.is_contact_only = false;
					putGuarantor.is_personal_guarantor = false;
					putGuarantor.business_entity_type = guarInfo.business_entity_type;
					putGuarantor.guarantor.lessee = app?.lessee;
					putGuarantor.guarantor.record_type = "Corporate Guarantor";
					putGuarantor.primary = false;
				} else if (guarInfo.guarantor_type === "Personal") {
					putGuarantor.is_corporate_guarantor = false;
					putGuarantor.is_contact_only = false;
					putGuarantor.is_personal_guarantor = true;
					putGuarantor.this_guarantor_has_signed_the_credit_application =
						guarInfo.this_guarantor_has_signed_the_credit_application;
					putGuarantor.marital_status = guarInfo.marital_status;
					putGuarantor.guarantor.record_type = "Personal Guarantor";
					putGuarantor.guarantor.lessee = app?.lessee;
					putGuarantor.primary = false;
				}

				const guarantorId = await GuarantorsDataAPI.postGuarantorData(
					putGuarantor.guarantor,
					app?.broker_id,
					app?.locked_by_email
				).catch((error) => {
					err = error?.message;
					setSpinner(false);
				});
				const guarantorApplicationInfo = [
					{
						// broker_id: gurantorData.broker_id,
						application_id: app?.id,
						guarantor_id: guarantorId,
						primary: putGuarantor?.primary,
						is_corporate_guarantor: putGuarantor?.is_corporate_guarantor || false,
						is_contact_only: putGuarantor?.is_contact_only || false,
						is_personal_guarantor: putGuarantor?.is_personal_guarantor || false,
						guarantor_type: putGuarantor?.guarantor_type,
						relationship_to_applicant:
							putGuarantor?.relationship_to_applicant || "owner",

						this_guarantor_has_signed_the_credit_application:
							putGuarantor?.this_guarantor_has_signed_the_credit_application || false,
						percent_of_ownership: putGuarantor?.percent_of_ownership,
						business_entity_type: putGuarantor?.business_entity_type,
					},
				];
				if (!err)
					await GuarantorsDataAPI.postGuarantorApplication(
						guarantorApplicationInfo,
						app?.broker_id,
						app?.locked_by_email
					).catch((error) => {
						err = error?.message;
					});;
			}
		} catch (error) {
			err = error?.message ?? "error";
		} finally {
			setSpinner(false);
			if (err) {
				setUI(<div style={{ color: "red" }}>{err}</div>);
			}
			else {
				setAddGuarantor(false);
				setEditGuarantorFlag(false);
				let appGuars = await GuarantorsDataAPI.getGuarantorsByAppId(
					app?.id,
					app?.broker_id,
					app?.locked_by_email
				);
				setGuarantorData(appGuars)
			}

		}
	}, [app?.broker_id, app?.id, app?.lessee, brokerId, guarInfo, guarantors, setEditGuarantorFlag, setGuarantorDataList, setGuarantors]);

	const handleFeinSSN = useCallback((name, numValue) => {
		const onlyNums = numValue.replace(/[^0-9]/g, "");
		if (name === "zip_code") {
			if (onlyNums.length <= 5)
				setGuarInfo({
					...guarInfo,
					guarantor: {
						...guarInfo.guarantor,
						[name]: onlyNums,
					},
				});
		}
		else {
			if (onlyNums.length <= 9)
				setGuarInfo({
					...guarInfo,
					guarantor: {
						...guarInfo.guarantor,
						[name]: onlyNums,
					},
				});
		}

	}, [guarInfo]);

	const handlePhoneNumber = useCallback((name, numValue) => {
		const onlyNums = numValue.replace(/[^0-9]/g, "");
		if (onlyNums.length < 10)
			setGuarInfo({
				...guarInfo,
				guarantor: {
					...guarInfo.guarantor,
					[name]: onlyNums,
				},
			});
		else if (onlyNums.length === 10) {
			const number = onlyNums.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
			setGuarInfo({
				...guarInfo,
				guarantor: {
					...guarInfo.guarantor,
					[name]: number,
				},
			});
		}
	}, [guarInfo]);

	const handleChange = useCallback((e, nested) => {
		const name = e.target.name;
		let value = e.target.value;
		if (nested) {
			if (name === "ssn" || name === "fein" || name === 'percent_of_ownership') handleFeinSSN(name, value);
			else if (name === "telephone" || name === "fax" || name === "mobile")
				handlePhoneNumber(name, value);
			else if (name === "zip_code")
				handleFeinSSN(name, value);
			else
				setGuarInfo({
					...guarInfo,
					guarantor: { ...guarInfo.guarantor, [name]: value },
				});
		} else setGuarInfo({ ...guarInfo, [name]: value });
	}, [guarInfo, handleFeinSSN, handlePhoneNumber]);

	useEffect(() => {
		const statesUSA = [];
		usStates.map((state) => {
			statesUSA.push(state.name);
		});
		setStateNames(statesUSA);
	}, []);

	useEffect(() => {
		setGuarInfo(guarantor);
	}, [guarantor]);

	return (
		<div style={{ overflow: "hidden", width: "100%" }}>
			<Dialog
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
				TransitionComponent={Transition}
				onClose={handleCancel}
				open={editGuarantorFlag}
				maxWidth="md"
				fullWidth
				style={{ zIndex: '0' }}>
				<DialogTitle>
					<Typography variant="h6">
						{guarInfo?.guarantor?.id ? "Edit" : "Add"} Guarantor
					</Typography>
				</DialogTitle>
				<DialogContent id="alert-dialog-description" dividers>
					{spinner ? (
						<NmefSpinner />
					) : (
						<Grid container direction="row" spacing={2}>
							<Grid item xs={2}>
								<Typography
									variant="subtitle2"
									align="right"
									style={{ fontWeight: "bold" }}>
									Guarantor Type * :
								</Typography>
							</Grid>
							{guarInfo?.guarantor?.id ? (
								<Grid item xs={2}>
									<Typography variant="subtitle2" align="left">
										{guarantor?.guarantor_type}
									</Typography>
								</Grid>
							) : (
								<Grid item xs={3}>
									<Select
										style={{ width: "100%", height: "100%" }}
										id="guarantorType"
										labelId="guarantorType"
										value={guarInfo?.guarantor_type ?? ""}
										onChange={(e) =>
											setGuarInfo({ ...guarInfo, guarantor_type: e.target.value })
										}>
										{guarantorTypeChoices.map((item, index) => (
											<MenuItem key={index} value={item}>
												{item}
											</MenuItem>
										))}
									</Select>
								</Grid>
							)}
							{guarInfo?.guarantor_type === "Personal" ? (
								<>
									<Grid item xs={5}>
										<Typography variant="subtitle2" align="right">
											This Guarantor has signed the credit application
										</Typography>
									</Grid>
									<Grid item xs={1}>
										<Checkbox
											color="primary"
											style={{ marginTop: "-10px" }}
											checked={
												guarInfo.this_guarantor_has_signed_the_credit_application ?? false
											}
											onChange={(e) =>
												setGuarInfo({
													...guarInfo,
													this_guarantor_has_signed_the_credit_application: e.target.checked,
												})
											}
										/>
									</Grid>
								</>
							) : null}

							{guarInfo?.guarantor_type === "Corporate" ? (
								<CorporateGuarantor
									guarantor={guarInfo}
									usStates={usStateNames}
									handleChange={handleChange}
									setGuarantorInfo={setGuarInfo}
								/>
							) : (
								<PersonalGuarantor
									guarantor={guarInfo}
									usStates={usStateNames}
									handleChange={handleChange}
									setGuarantorInfo={setGuarInfo}
								/>
							)}
							<Grid item xs={4} align="center"></Grid>
							<Grid item xs={2} align="center">
								<Button onClick={() => {
									if (
										((guarInfo.guarantor_type === "Personal" ||
											guarInfo.guarantor_type === "Contact Only") &&
											isFormValidPersonal()) ||
										(guarInfo.guarantor_type === "Corporate" &&
											isFormValidCorporate())
									) {
										saveGuarantor();
									} else {
										setErrorFlag(true);
									}
								}} variant="contained">
									Save
								</Button>
							</Grid>
							<Grid item xs={2} align="center">
								<Button onClick={handleCancel} variant="contained">
									Cancel
								</Button>
							</Grid>
						</Grid>
					)}
					<Grid container direction="row" spacing={1}>
						<Grid item xs={12}>
							{UI}
						</Grid>
					</Grid>
					{errorFlag ? (
						<div style={{ color: "red" }}>Please enter all the required fields</div>
					) : null}
				</DialogContent>
			</Dialog>
		</div>
	);
}
